export const name = 'gzMonthSelectorChangeDatesController';
export default function GzMonthSelectorChangeDatesController(
  $mdDialog,
  $translate,
  moment,
  created
  ) {

  //noinspection BadExpressionStatementJS
  'ngInject';

  const MONTHS = moment.months();

  let vm = this;

  vm.isOrgOrigination = false;
  vm.created = created;

  vm.cancel = cancel;
  vm.submit = submit;
  vm.initiateMonths = initiateMonths;
  vm.updateOrgOrigination = updateOrgOrigination;

  vm.test = {
    initiateYears: initiateYears,
    initiateMonths: initiateMonths
  };

  activate();

  //////////////

  function activate() {
    initiateYears();
    initiateMonths();
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function submit() {
    let monthIndex = _.findIndex(MONTHS, m => { return m === vm.selectedMonth; });
    $mdDialog.hide(moment([vm.selectedYear, monthIndex]));
  }

  function initiateMonths() {
    let today = moment();

    // moment.month() uses 0-indexed months so we'll use this convention too
    let startMonth = vm.selectedYear === vm.created.year() ? vm.created.month() : 0;
    // We don't want to go beyond the current month of the current year
    let endMonth = vm.selectedYear === today.year() ? today.month() : 11;

    vm.availableMonths = [];
    for (let i = startMonth; i <= endMonth; i++) {
      vm.availableMonths.push(MONTHS[i]);
    }

    if (vm.selectedMonth === undefined) {
      // Initialize to today's month if it's the current year, otherwise, initialize to the first month in the
      // selected year.
      if (vm.selectedYear === today.year()) {
        vm.selectedMonth = vm.availableMonths[today.month()];
      }
      else {
        vm.selectedMonth = vm.availableMonths[0];
      }
    }

    updateOrgOrigination();
  }

  function initiateYears() {
    let today = moment();

    // Initialize to today's year
    vm.selectedYear = today.year();

    vm.availableYears = [];
    for (let i = vm.created.year(); i <= vm.selectedYear; i++) {
      vm.availableYears.push(i);
    }
  }

  function updateOrgOrigination() {
    vm.isOrgOrigination =  vm.selectedYear === vm.created.year() &&
                           vm.selectedMonth === vm.created.format('MMMM');
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/month-selector/change_dates.controller.js